/**
 * inspired by https://gist.github.com/piecioshka/cce6ea53ba0db1a4700e
 * does need to be improved its a bit brittle as we are using a canvas to measure the text and assuming the font.
 */
export const truncateText = (
  text: string,
  maxWidth: number,
  maxHeight: number,
  fontSize: number,
  fontWeight: string | number
) => {
  const padding = 5;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return text;
  context.font = `${fontWeight} ${fontSize}px Roboto Flex`;

  let truncatedText = text;
  let width = context.measureText(truncatedText).width + padding;
  let actualHeight =
    context.measureText(truncatedText).actualBoundingBoxAscent +
    context.measureText(truncatedText).actualBoundingBoxDescent;

  if (actualHeight >= maxHeight) {
    return '';
  }

  const ellipsis = '\u2026';

  while (width > maxWidth && truncatedText.length > 0) {
    truncatedText = truncatedText.substring(0, truncatedText.length - 1);
    width = context.measureText(truncatedText + ellipsis).width + padding;
  }

  if (truncatedText !== text) {
    truncatedText += ellipsis;
  }

  if (truncatedText === ellipsis && width > maxWidth) {
    return '';
  }

  return truncatedText;
};
